export default {
  itemList: [],
  attributes: [],
  recommendedAttributes: [],
  documentTypes: [],
  loading: false
}
